// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"348":"bcf967e9","677":"61bfa7bd","746":"b33b02ce"}[chunkId] + ".js";
};